module.exports = __webpack_public_path__ + "img/dragonsoft.633d6ae9.png";